import axios from 'axios';
import { SIMULATION_ENDPOINT } from '../Configs';

export const ServiceEngine = axios.create({
    baseURL: SIMULATION_ENDPOINT,
    timeout: 100000,
    headers: {
        'Content-Type': 'application/json'
    }
});

export const SetAuthHeader = (token, connectionId) => {
    ServiceEngine.defaults.headers.common.Authorization =  token
    ServiceEngine.defaults.headers.common.ConnectionId =  connectionId;
};

// we can also have interceptors in case we need to handle http requests

export default {
    ServiceEngine,
    SetAuthHeader
};